import { Datalayer, IDataLayer, IDatalayerContext } from "../omnia"

import IMap = omnia.map.IMap
import { ol_ImageLayer, ol_source, ol_layer } from "@omnia/exports/openlayers"

export class PictureLayer extends Datalayer {

    private _satellite: boolean

    private _imgSource: ol_source.ImageStatic
    private _imgLayer: ol_ImageLayer


    constructor(datalayer: IDataLayer, _context: IDatalayerContext, private apiUrl: string) {
        super(null, _context)
        this._satellite = !!datalayer.Satellite
        this.initialize(datalayer)
    }

    protected initialize(datalayer: IDataLayer) {

        super.initialize(datalayer)

        let pictureInfo = datalayer.GeorefPicture

        if (pictureInfo) {

            const path = encodeURIComponent(pictureInfo.Path)
            const url = this.apiUrl + `/api/img/?path=${path}&v=${Date.now()}`

            this._imgSource = new ol_source.ImageStatic({
                imageExtent: pictureInfo.Extent,
                url: url,
                projection: "EPSG:3857"
            })

            this._genericLayer = this._imgLayer = new ol_layer.Image({
                source: this._imgSource
            })

        }

    }

    addToMap(map: IMap) {
        if (this._satellite) {
            super.addToMap(map)
        }
        else {
            map.pictureLayersGroup.getLayers().push(this._imgLayer)
        }
    }

    removeFromMap(map: IMap) {
        if (this._satellite) {
            super.removeFromMap(map)
        }
        else {
            map.pictureLayersGroup.getLayers().remove(this._imgLayer)
        }
    }

}
